export default __webpack_public_path__ + "static/common-app-logo-white-new-2b788a1d68a1d85e1e3a39609da93c7a.svg";